import { Moment } from 'moment'

import { OffAdCritterCustomOption } from './Organization'
import { Persona } from './Persona'

export interface MasterCampaignPlan {
  id: string
  organizationId: string
  accountId: string
  masterCampaignStubId: string
  masterCampaignId: string
  name: string
  status: MasterCampaignPlanStatus
  details: string
  created: Moment
  resources: MasterCampaignPlanResources
  planSummary: string
  planDetails: string
  audienceSummary: string
  audienceDetails: string
  geoSummary: string
  geoDetails: string
  seasonalitySummary: string
  seasonalityDetails: string
  personas: Persona[]
  marketAnalysisContent?: string
  aiUsedMonthlyBudgetMin: number
  aiUsedMonthlyBudgetMax: number
  aiUsedSingleBudgetMax: number
  aiUsedStartDate: Moment
  aiUsedDurationInMonths: number
  aiRecommendedBudget: boolean
  monthlyBudgetMin: number
  monthlyBudgetMax: number
  maxSingleBudget?: number
  aiRecommendedStartAndDuration: boolean
  startDate: string
  inEditMode: boolean
  publicId?: string
  highlightedDomainIds?: string[]
  internetMarginOfError: number
  tvMarginOfError: number
  billboardMarginOfError: number
  tvNetworkDistribution?: Record<string, number>
  offAdCritterCustomOptions?: OffAdCritterCustomOption[]
  clientPreviewShowExecutiveSummary?: boolean
  clientPreviewShowMarketAnalysis?: boolean
  clientPreviewShowPersonas?: boolean
  clientPreviewShowMediaPlan?: boolean
  clientPreviewShowProjections?: boolean
}

export interface MasterCampaignPlanResources {
  marketAnalysisAvailable: boolean
  marketingPlanAvailable: boolean
  campaignDetailsAndRationaleAvailable: boolean
  pitchDeckAvailable: boolean
}

export enum MasterCampaignPlanResourceType {
  MarketAnalysis = 'MarketAnalysis',
  MarketingPlan = 'MarketingPlan',
  CampaignDetailsAndRationale = 'CampaignDetailsAndRationale',
  PitchDeck = 'PitchDeck'
}

export enum MasterCampaignPlanStatus {
  Processing = 'Processing',
  Ready = 'Ready',
  TransferredToDsp = 'TransferredToDsp',
  Deleted = 'Deleted',
  Migrating = 'Migrating'
}

export interface MasterCampaignPlanCustomSection {
  id: string
  title: string
  showTitle?: boolean
  content: string
  hideAll?: boolean
  createdBy: string
  createdAt: Moment
  updatedBy: string
  updatedAt: Moment
}
